import { PolygraphyProductFormat } from '../../../../../services/exports/Constants';

export default {
  form: {
    name: {
      label: 'Dai un nome a questo lavoro di stampa',
      placeholder: 'Volantino A5 - promozione speciale',
    },
    format: {
      label: 'Tipo di prodotto',
      placeholder: 'Seleziona tipo di prodotto',
      options: {
        [PolygraphyProductFormat.FlyerA5]: 'Volantino (A5)',
        [PolygraphyProductFormat.FlyerA6]: 'Volantino (A6)',
        [PolygraphyProductFormat.Sticker60x60]: 'Adesivo (60x60mm)',
        [PolygraphyProductFormat.DoorStickerA5]: 'Adesivo porta (30x30cm)',
      },
    },
    file: {
      label: 'File',
    },
  },
  buttons: {
    upload: 'Clicca o trascina per caricare il file',
    save: 'Salva',
  },
  toasts: {
    changes_got_saved: 'Modifiche salvate!',
  },
};
